export default __webpack_public_path__ + "static/media/img_base_lemon.7e9dc1b9.jpg";